import { Reveal } from "@/components/Reveal";

const chapters = [
  {
    n: "01",
    title: "The Profile",
    body: "Most talent gets lost in bad photos and weaker positioning. We art-direct your book, build a magnetic digital profile, and tell the story casting directors actually remember.",
  },
  {
    n: "02",
    title: "The Rooms",
    body: "Talent alone doesn't open doors — relationships do. We put your face in front of the brands, agencies, and creatives who write the cheques and shape the culture.",
  },
  {
    n: "03",
    title: "The Deals",
    body: "From single shoots to long-term ambassadorships, we negotiate rates that respect your worth and structure deals that compound into a career, not a one-off gig.",
  },
  {
    n: "04",
    title: "The Career",
    body: "Being booked once is luck. Staying booked is strategy. We manage your trajectory so the girl who once dreamt of the cover ends up living on it.",
  },
];

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="bg-[#ffffff] text-[#0a0a0a] py-24 md:py-40 px-6 md:px-10"
    >
      <div className="max-w-[1600px] mx-auto">
        <Reveal>
          <div className="flex items-center gap-4 mb-8">
            <span className="h-px w-12 bg-[#000000]" />
            <span className="text-xs uppercase tracking-[0.3em] font-bold text-[#737373]">
              The Manifesto
            </span>
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-7xl font-light tracking-tight leading-[0.95] max-w-4xl">
            We don&rsquo;t sell dreams. We build the <span className="italic text-[#000000]">machine</span> that makes them inevitable.
          </h2>
          <p className="font-script text-[#000000] text-4xl md:text-6xl leading-none mt-8">
            stop waiting to be discovered.
          </p>
        </Reveal>

        <div className="mt-20 md:mt-28 flex flex-col">
          {chapters.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.05}>
              <div
                data-testid={`manifesto-chapter-${c.n}`}
                className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 border-t border-[#0a0a0a]/20 py-10 md:py-14 group"
              >
                <div className="md:col-span-3">
                  <span className="font-display text-6xl md:text-8xl font-light text-[#000000] tracking-tighter block leading-none">
                    {c.n}
                  </span>
                </div>
                <div className="md:col-span-4">
                  <h3 className="font-display text-3xl md:text-4xl font-medium tracking-tight">
                    {c.title}
                  </h3>
                </div>
                <div className="md:col-span-5">
                  <p className="text-base md:text-lg text-[#0a0a0a]/70 leading-relaxed">
                    {c.body}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
